var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"screen_components"},[_c('CardItem',{attrs:{"name":"直播间LOGO","editVisible":true,"authVisible":_vm.authVisible}}),_c('CardItem',{attrs:{"name":"直播间信息","editVisible":true,"authVisible":_vm.authVisible}}),_c('CardItem',{attrs:{"name":"行情滚动图","editVisible":true,"authVisible":_vm.authVisible}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }